<template>
<div class="border d-flex flex-column rounded-bottom-10 rounded-top-10 h-100 ">
    <span v-if="splitedExpertImageUrl">
        <a :href="[realUrl]" class="position-relative brand-poc-card-img">
            <img class="rounded-top-l-10 w-50 splited__image__left" :style="{'background-color':parentColorHexCode}" :alt="localPoc.title" v-if="parentLogo" :src="parentLogo" />
            <img class="rounded-top-r-10 w-50 splited__image__right object-f-c" v-if="splitedExpertImageUrl" :alt="localPoc.title" :src="splitedExpertImageUrl" />
            <h4 class="sands--hide" v-if="localPoc.title">{{localPoc.title}}</h4>
        </a>
    </span>
    <span v-else>
        <a :href="[realUrl]" class="position-relative brand-poc-card-img">
            <img class="rounded-top-10 w-100" :alt="localPoc.title" v-if="teaserImage" :src="teaserImage" />
            <img class="rounded-top-10 w-100" :alt="localPoc.title" v-if="!teaserImage" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/loading_Image_top_image.svg" />
            <h4 class="sands--hide" v-if="localPoc.title">{{localPoc.title}}</h4>
        </a>
    </span>
    <div class="card-body px-2 poc-card-body-h d-flex flex-column pb-1 justify-content-between">
        <!-- parent logo and Name  and poc type-->
        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex justify-content-between w-100 min-h-28-p">
                <div class="parent-logo-wrapper mt-1 d-flex align-items-center">
                    <!-- <img class="parent-logo rounded-sm" :style="{ backgroundColor: singlePoc.parentColorHexCode}" v-if="singlePoc.parentLogo" :src="singlePoc.parentLogo" /> -->
                    <!-- <p v-if="localPoc.parentName" class="m-0 font-weight-bold">{{cuteventName(localPoc.parentName)}}</p> -->
                     <p v-if="localPoc.brandName" class="m-0 font-weight-bold">{{cuteventName(localPoc.brandName)}}</p>
                </div>
                <div v-if="rgbaColor" class="d-flex mt-1">
                    <div v-if="poclabel" 
                    :style="{
                  background: 'rgba('+ rgbaColor.r +','+ rgbaColor.g +','+ rgbaColor.b +',0.2)'}"
                     class="align-items-center badge d-flex poc-badge position-relative poc-tooltip-container"
                     :data-toggle="showBadgeTooltip ? 'tooltip' : ''"
                     data-placement="bottom"
                     :title="showBadgeTooltip ? getPocLabelDescription() : ''">
                        <p class="sm--text-poc small m-0 ml-1 p-0" v-if="poclabel">{{poclabel}}
                        </p>
                        <img v-if="isReadContent" class="mx-1 poc-lable-icon" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/read-Vector-dark.svg" alt="">
                        <img v-if="!isReadContent" class="mx-1 poc-lable-icon-play" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/play-Vector-dark.svg" alt="">
                    </div>
                    <div v-if="localPoc.language" class="ml-2 d-flex px-1 rounded align-items-center"  :style="{
                  background: 'rgba('+ rgbaColor.r +','+ rgbaColor.g +','+ rgbaColor.b +',0.2)'}">
                        <p class="sm--text-poc small m-0 p-0">{{localPoc.language}}</p>
                    </div>
                </div>
            </div>
            <a class="position-relative brand-poc-card-img" :href="[realUrl]">
                <h4 class="font-weight-bold my-3 w-100 single-poc-t-mh h5 text-dark text-break" v-if="localPoc.title">{{localPoc.title}}</h4>
            </a>
             <p v-if="localPoc.parentName && localPoc.parentGenre == 'FSLE'" class="h6 mb-3 mt-n2 text-break">{{localPoc.parentName}}</p>
        </div>
        <div class="mb-3">
            <p v-if="localPoc.subtitle" class="h6">
                {{localPoc.subtitle}}
            </p>
            <div class="d-flex flex-wrap text-black-50 poc-expert-font-s-f poc-small-text mt-3">
                <template v-if="localPoc.experts && localPoc.experts.length">
                    <div class="flex-shrink-0" v-for="(expert, index) in localPoc.experts.slice(0,2)" :key="index">
                        <div v-if="expert && expert.name">{{expert.name}}<span v-if="localPoc.experts && localPoc.experts.length > 1 && index < 1">,&nbsp;</span></div>
                    </div>
                    <div class="flex-shrink-0" v-if="localPoc.expertNames && localPoc.expertNames.length > 1">&nbsp;
                        <span>{{ $t('BrandComplex.andMore') }}</span>
                    </div>
                </template>
            </div>
            <div class="d-flex justify-content-between mt-1 align-items-center">
                <div v-if="localPoc.duration && localPoc.duration > 60 && localPoc.isReadContent === true">
                    <span :style="{ color: localPoc.parentColorHexCode }" class="poc-small-text">{{Math.floor(singlePoc.duration/60)}} 
                        <span>{{ $t('BrandComplex.minRead') }}</span>
                    </span>
                </div>
                <div v-if="!isReadContent && displayDateTime && localPoc.parentColorHexCode" :style="{ color: localPoc.parentColorHexCode }" class="poc-small-text">{{displayDateTime}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import helperfunctions from "../../services/helperfunctions.js";

export default {
    name: "singlePoc",
    created() {
        this.setExpertImageUrl(this.singlePoc);
        if (this.singlePoc.parentColorHexCode) {
            this.parentColorHexCode = this.singlePoc.parentColorHexCode;
        }
    },
    data() {
        return {
            displayImage: false,
            isReadContent: false,
            displayDateTime: null,
            bgColor: '#007d8d',
            splitedExpertImageUrl: '',
            teaserImage: '',
            parentLogo: '',
            poclabel: String,
            parentColorHexCode: '',
            rgbaColor: { r: 20, g: 147, b: 92, a: 1 },
            parentName: '',
            title: '',
            localPoc: { ...this.singlePoc },
            language: 'DE',
        };
    },
    props: {
        singlePoc: Object,
        realUrl: String,
        isDevMioActive: Boolean,
        isDevmioNlActive: Boolean,
        showBadgeTooltip: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.getLanguage()
        this.setImageForPoc();
        this.formatDates();
        this.getCorrectPocType();
        this.rgbaColor = helperfunctions.hexToRgb(this.parentColorHexCode);
        this.switchTitlwWithParentNameForCamps(this.localPoc);
        
        // Initialize Bootstrap 4 tooltips
        this.$nextTick(() => {
            if (window.jQuery) {
                window.jQuery('[data-toggle="tooltip"]').tooltip();
            }
        });
    },
    methods: {
    setExpertImageUrl(poc) {
        if (poc && poc.parentGenre && (poc.parentGenre == "RHEINGOLD" || poc.parentGenre == "FLEX_CAMP" || poc.parentGenre == "CAMP")) {
            if (poc.parentLogo) {
                this.parentLogo = poc.parentLogo;
            } else {
                this.parentLogo = !this.isDevMioActive ? '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/entwickler__teasimage.svg' : '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/devmio.svg';
            }
            if (poc && poc.experts && poc.experts.length && poc.experts[0] && poc.experts[0].image) {
                this.splitedExpertImageUrl = poc.experts[0].image;
            } else {
                this.splitedExpertImageUrl = 'https://redsys-prod.s3.eu-west-1.amazonaws.com/mustermann_max_ek_1558014709503_xxxx.png'
            }
        }
    },
    formatDates() {
        let language;
        let availableUntilText;
        let liveEventText;
        if (this.isDevMioActive || this.isDevmioNlActive) {
            availableUntilText = 'Available until ';
            liveEventText = 'Live in ';
            language = 'EN';
        } else {
            availableUntilText = 'Aufzeichnung Verfügbar bis ';
            liveEventText = 'Live am ';
            language = 'DE';
        }
        if(!this.localPoc.isReadContent && this.localPoc.startDate && this.localPoc.endDate && 
        moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss').isValid() && moment(this.localPoc.endDate, 'DD-MM-YYYY HH:mm:ss').isValid()){
          if (this.localPoc.isMyEvent) {
            this.displayDateTime = moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', language).format('dddd') + ' - ' + moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', this.language).format('LL');
          }else if(this.localPoc.parentGenre){
            if(this.localPoc.parentGenre === 'TUTORIAL' || this.localPoc.parentGenre === 'COURSE'){
              return;
            }
            else if(this.localPoc.parentGenre === 'RHEINGOLD' || this.localPoc.parentGenre === 'CAMP' || this.localPoc.parentGenre === 'FLEX_CAMP'){
              this.displayDateTime = moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', language).format('dddd') + ' - ' + moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', this.language).format('DD. MMM YYYY');
            }else if(this.localPoc.parentGenre === 'FSLE'){
              //check if this.pieceOfContent.startDate is in future then show the date
              let currentDate = moment().subtract(1, 'days');
              let eventStartDate = moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss');
              if (eventStartDate > currentDate) {
                this.displayDateTime =  liveEventText + moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', language).format('LL') + ' | ' + moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', this.language).format('LT');
              }else{
                //we need to display avaliable until date
                if (this.localPoc.availableUntilDate && moment(this.localPoc.availableUntilDate, 'DD-MM-YYYY HH:mm:ss').isValid()) {
                  this.displayDateTime = availableUntilText + moment(this.localPoc.availableUntilDate, 'DD-MM-YYYY HH:mm:ss', language).format('LL');
                }
              }
            }else{
              this.displayDateTime = moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', language).format('LL') + ' | ' + moment(this.localPoc.startDate, 'DD-MM-YYYY HH:mm:ss', this.language).format('LT');
            }
          }
      }
    },
    setImageForPoc() {
        if (!this.localPoc.parentColorHexCode) {
            this.parentColorHexCode = !this.isDevMioActive ? '#00A19A' : '#34046E';
        }
        if (this.localPoc.schemaType) {
            if (this.localPoc.teaserImage) {
                this.teaserImage = this.localPoc.teaserImage;
            }
            if (!this.localPoc.teaserImage) {
                if (this.localPoc.parentLogo) {
                    this.teaserImage = this.localPoc.parentLogo;
                } else if (!this.localPoc.parentLogo) {
                    this.teaserImage = !this.isDevMioActive ? '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/entwickler__teasimage.svg' : '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/devmio.svg';
                }
            }
        }
    },
    getCorrectPocType() {
        if (this.localPoc) {
            if (this.localPoc.isReadContent && ((this.localPoc.parentGenre && this.localPoc.parentGenre != 'COURSE') || !this.localPoc.parentGenre)) {
                this.isReadContent = true;
                this.poclabel = 'Artikel';
                this.pocType = 'Artikel';
                if (this.language === 'EN') {
                    this.poclabel = 'Article';
                } else if (this.language === 'NL') {
                    this.poclabel = 'Artikel';
                }
            } else if (this.localPoc.parentGenre && this.localPoc.parentSchemaType && this.localPoc.schemaType) {
                this.poclabel = helperfunctions.getCorrectPocType(this.localPoc.parentGenre, this.localPoc.parentSchemaType, this.localPoc.schemaType);
            }
        }
        return;
    },
    switchTitlwWithParentNameForCamps(poc) {
        if (poc.parentGenre && (poc.parentGenre == "FLEX_CAMP" || poc.parentGenre == "COURSE" || poc.parentGenre == "CAMP" || poc.parentGenre == "TUTORIAL")) {
            let title, parentName;
            if (poc.brandName && poc.brandName.length) {
                title = poc.brandName;
            }
            if (poc.parentName && poc.parentName.length) {
                parentName = poc.parentName;
            }
            poc.title = parentName;
            poc.parentName = title;
        }
    },
    cuteventName(eventName) {
        if (eventName && eventName.length > 24) {
            eventName = eventName.slice(0, 24) + "...";
        }
        return eventName;
    },
    getLanguage() {
        if (this.isDevMioActive || this.isDevmioNlActive) {
            this.language = 'EN';
        } else {
            this.language = 'DE';
        }
    },
    getPocLabelDescription() {
        const labelDescriptions = {
            'DE': {
                'Artikel': 'ARTIKEL VON EXPERT:INNEN AUS DER PRAXIS, DIE KONKRETE FRAGSTELLUNGEN UND LÖSUNGANSÄTZE BELEUCHTEN',
                'Live Event': 'EIN LIVE-STREAMING-EVENT, DAS VON EXPERT:INNEN GELEITET WIRD UND INTERAKTIVE ELEMENTE FÜR DIE TEILNEHMER BIETET',
                'Session': 'EINE EINZELNE SITZUNG ODER EIN TEIL EINES GRÖSSEREN EVENTS, DAS SICH AUF EIN BESTIMMTES THEMA KONZENTRIERT',
            },
            'EN': {
                'Article': 'AN ARTICLE BY PRACTITIONER EXPERTS THAT ILLUMINATES SPECIFIC QUESTIONS AND SOLUTION APPROACHES',
                'Live Event': 'A LIVE STREAMING EVENT LED BY EXPERTS AND OFFERING INTERACTIVE ELEMENTS FOR PARTICIPANTS',
                'Session': 'A SINGLE SESSION OR PART OF A LARGER EVENT FOCUSED ON A SPECIFIC TOPIC'
            },
            'NL': {
                'Artikel': 'EEN ARTIKEL DOOR PRAKTIJKEXPERTS DAT SPECIFIEKE VRAGEN EN OPLOSSINGSBENADERINGEN VERLICHT',
                'Live Event': 'EEN LIVE STREAMING-EVENEMENT GELEID DOOR EXPERTS EN BIEDT INTERACTIEVE ELEMENTEN VOOR DEELNEMERS',
                'Session': 'EEN ENKELE SESSIE OF DEEL VAN EEN GROTER EVENEMENT GERICHT OP EEN SPECIFIEK ONDERWERP'
            }
        };
        
        const descriptions = labelDescriptions[this.language] || labelDescriptions['DE'];
        return descriptions[this.poclabel] || this.poclabel;
    }
},

};
</script>

<style lang="css" scoped>
.brand-poc-card-img img {
    height: 175px;
    width: 100%;
    object-fit: cover;

}

@media screen and (max-width: 767px) {
.brand-poc-card-img img {
    height: 100%;
}
}

@media screen and (min-width: 1281px) and (max-width: 1680px) {
  .brand-poc-card-img img {
    height: 135px;
  }
}

.poc-lable-icon{
    height: 15px;
}
.poc-lable-icon-play{
    height: 10px;
}

.poc-card-body-h {
    min-height: 184px;
    width: 100%;
}

.parent-logo-wrapper img {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
    margin-right: 5px;
    padding: 0.5px;

}

.parent-logo-wrapper p {
    font-size: 12px;
}

.poc-expert-font-s-f {
    font-size: 12px;
    font-family: sans-serif;
}

.live--svg {
    margin-left: 0.35rem;
}
.object-f-c{
    object-fit: cover;
}

.sm--text-poc {
    text-align: center;
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.min-h-28-p {
    min-height: 28px;
}

.min-h-28-p div {
    height: 20px;
}

.single-poc-t-mh {
    min-height: 71px;
}

.poc-small-text {
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.small {
    font-size: 10px!important;
}

.splited__image__left{
    object-fit: contain !important;
}

.splited__image__right{
    object-fit: cover;
}
</style>
<style>
.tooltip .tooltip-inner{
    background-color: white;
    border: 2px solid #147778;
    border-radius: 10px;
    width: 280px !important;
    color: grey;
    font-weight: bold;
}
/* hide the arrow */
.tooltip .arrow {
    display: none;
}
</style>